module.exports = __webpack_public_path__ + "img/E-WEB-Goal-16.49be380b.png";